"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDocumentTranslateState = void 0;
exports.defaultDocumentTranslateState = {
    pendingPageTitle: 'Pending Documents',
    signedPageTitle: 'Signed Documents',
    pendingPageCaption: 'Review and sign documents from OKAY.com',
    signedPageCaption: 'View signed documents from OKAY.com',
    pendingEmpty: 'No Pending Documents',
    signedEmpty: 'No Signed Documents yet',
    viewProperties: 'View {} Properties',
    viewProperty: 'View {}',
    completed: 'Completed',
    notStarted: 'Preparing',
    pendingSignature: 'Pending Signature',
    pendingOthers: 'Pending Others',
    reviewAndSign: 'Review & Sign',
    view: 'View',
    sfS: 'SF (S)',
    sfG: 'SF (G)',
    beds: 'BD',
    baths: 'BA',
    form: 'Form {}',
    noImage: 'N/A',
    sortBy: 'Sort By',
    showingRecords: 'Showing {}-{} / {} records',
    sortFormTypeAsc: 'EAA Form Type (1 to 6)',
    sortFormTypeDesc: 'EAA Form Type (6 to 1)',
    sortCreateDateAsc: 'Form Creation Date (Old to New)',
    sortCreateDateDesc: 'Form Creation Date (New to Old)',
    askingPrice: 'Asking Price',
};
